export default __webpack_public_path__ + "static/media/GPA_Banner_Residential_Manage_My_Account.5f433042.jpg";